"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UxEventLoggerService = void 0;
var ua_parser_js_1 = require("ua-parser-js");
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var Credential_service_1 = require("../jsonServiceApi/Credential.service");
var Guid_service_1 = require("../Guid.service");
var JsonApi_service_1 = require("../jsonServiceApi/JsonApi.service");
var EmbeddedApp_service_1 = require("../EmbeddedApp.service");
var objectUtil_1 = require("../../../util/objectUtil");
var handledAppOpen = false;
var uaParser = new ua_parser_js_1.UAParser();
var uaData = uaParser.getResult();
/**
 * The UxEventLogger Service is made to replace uxEventLoggerBusiness in fullbundle
 * How to use:
 *     uxEventLoggerService.appOpenEvent();
 *     uxEventLoggerService.contentOpenEvent({ contentSource,uxContext,versionId,product });
 *     uxEventLoggerService.navigateEvent({ uxContext,target,product });
 *     uxEventLoggerService.componentAppOpenEvent({ application, product });
 *     uxEventLoggerService.componentNavigateEvent({ uxContext,target,application,product });
 */
var UxEventLoggerService = /** @class */ (function () {
    function UxEventLoggerService(credentialService, jsonApiService, embeddedAppService, guidService) {
        this.credentialService = credentialService;
        this.jsonApiService = jsonApiService;
        this.embeddedAppService = embeddedAppService;
        this.guidService = guidService;
        this.sessionToken = this.guidService.generate();
    }
    UxEventLoggerService.prototype.handleEvent = function (createdEvent) {
        var event = {};
        objectUtil_1.deepMerge(event, this.getBaseEvent());
        objectUtil_1.deepMerge(event, createdEvent);
        try {
            this.logEvent({ WrappedEvent: event });
        }
        catch (e) {
            console.error('UXEvent log failed.', e);
            console.error(event);
        }
    };
    UxEventLoggerService.prototype.getBaseEvent = function () {
        var loginInfo = this.credentialService.getSecurityCredentials();
        if (!loginInfo)
            return {};
        var tenant = loginInfo.Tenant;
        var host = {};
        if (this.embeddedAppService.hasContext()) {
            var context = this.embeddedAppService.getContext();
            if (context)
                host = {
                    Trace: {
                        HostName: context.SystemType,
                        HostVersion: context.ApplicationVersion,
                    },
                };
        }
        var event = {
            Tenant: tenant,
            UserId: loginInfo.UserId,
            CollectedAt: new Date().toISOString(),
            SessionToken: this.sessionToken,
            DataVersion: 'e7f84b2d-8b7e-4e4f-bc8b-56022714204c',
            Type: 'ux-event',
            Trace: {
                Product: 'Unknown',
                Application: this.embeddedAppService.isEmbeddedApp() ? 'EmbeddedApp' : 'WebApp',
                OperatingSystem: uaData.os.name,
                OperatingSystemDetail: uaData.os.version,
                Context: {
                    Tenant: tenant,
                    UserAgent: uaParser.getUA(),
                },
            },
            ClientWidth: document.documentElement.clientWidth,
            ClientHeight: document.documentElement.clientHeight,
        };
        objectUtil_1.deepMerge(event, host);
        return event;
    };
    UxEventLoggerService.prototype.logEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var data, body;
            return __generator(this, function (_a) {
                data = JSON.stringify([event]);
                body = JSON.stringify(data);
                this.jsonApiService.post('DataCollectionService', 'SeismicLogEvents', body, {});
                return [2 /*return*/];
            });
        });
    };
    UxEventLoggerService.prototype.getApplicationAndProduct = function (eventContext) {
        if (eventContext) {
            return {
                Trace: {
                    Application: eventContext.application,
                    Product: eventContext.product,
                },
            };
        }
        return {};
    };
    //Public methods:
    UxEventLoggerService.prototype.appOpenEvent = function () {
        if (handledAppOpen) {
            return;
        }
        console.debug('sending application open event');
        var event = {
            SubType: 'ux-app-open',
        };
        this.handleEvent(event);
        handledAppOpen = true;
    };
    UxEventLoggerService.prototype.contentOpenEvent = function (eventContext) {
        this.handleEvent({
            ContentSource: eventContext.contentSource,
            UXContext: eventContext.uxContext,
            VersionId: eventContext.versionId,
            Trace: {
                Product: eventContext.product,
            },
            SubType: 'ux-content-open',
        });
    };
    UxEventLoggerService.prototype.navigateEvent = function (eventContext) {
        var event = {
            UXContext: eventContext.uxContext,
            Target: eventContext.target,
            Trace: {
                Product: eventContext.product,
            },
            SubType: 'ux-navigate',
        };
        this.handleEvent(event);
    };
    UxEventLoggerService.prototype.componentAppOpenEvent = function (eventContext) {
        var event = {};
        objectUtil_1.deepMerge(event, { SubType: 'ux-app-open' });
        objectUtil_1.deepMerge(event, this.getApplicationAndProduct(eventContext));
        this.handleEvent(event);
    };
    UxEventLoggerService.prototype.componentNavigateEvent = function (eventContext) {
        var event = {
            UXContext: eventContext.uxContext,
            Target: eventContext.target,
            Trace: {
                Application: eventContext.application,
                Product: eventContext.product,
            },
            SubType: 'ux-navigate',
        };
        this.handleEvent(event);
    };
    UxEventLoggerService = __decorate([
        CommonService_decorator_1.CommonService('UxEventLoggerService'),
        __metadata("design:paramtypes", [Credential_service_1.CredentialService,
            JsonApi_service_1.JsonApiService,
            EmbeddedApp_service_1.EmbeddedAppService,
            Guid_service_1.GuidService])
    ], UxEventLoggerService);
    return UxEventLoggerService;
}());
exports.UxEventLoggerService = UxEventLoggerService;
//# sourceMappingURL=UxEventLogger.service.js.map